<script setup lang="ts">
import InputNumber from '@/components/input-number.vue';
import InvoiceSkeletonPlaceholderText from '@/features/invoices/components/partials/InvoiceSkeletonPlaceholderText.vue'
import { format } from 'date-fns/format'

defineProps<{
  invoiceNumber?: string
  date?: Date
  dateFormat: string
  period?: [Date, Date]
  isManualInvoice: boolean
  recsEnabled: boolean
}>()
const recsGenerated = defineModel<number>('recsGenerated')
</script>

<template>
  <div :class="$style.wrapper" class="d-grid">
    <span>Invoice Number</span>
    <span>
      <template v-if="invoiceNumber">{{ invoiceNumber }}</template>
      <InvoiceSkeletonPlaceholderText v-else />
    </span>

    <span>Invoice Date</span>
    <span>
      <template v-if="date">{{ format(date, dateFormat) }}</template>
      <InvoiceSkeletonPlaceholderText v-else />
    </span>
    
    <span>Invoice Period</span>
    <span>
      <template v-if="period">{{ format(period[0].toISOString().split('Z')[0], dateFormat) }} - {{ format(period[1].toISOString().split('Z')[0], dateFormat) }}</template>
      <InvoiceSkeletonPlaceholderText v-else />
    </span>

    <template v-if="recsEnabled">
      <span>REC's Generated</span>
      <span>
        <InputNumber v-if="recsGenerated != null" v-model:value="recsGenerated" />
        <InvoiceSkeletonPlaceholderText v-else />
      </span>
    </template>
  </div>
</template>

<style module lang="scss">
.wrapper {
  grid-template-columns: 1fr 1fr;
}
</style>
